import React, { useEffect, useState } from "react";
import "../css/App.css";
import { InView } from "react-intersection-observer";
import { useSpring, animated } from "react-spring";
import HoverCard from "./HoverCard.js";
import { isMobile } from "react-device-detect";

import { Element, scroller } from "react-scroll";

export default function AboutMe() {
  const [showH1, setShowH1] = useState(false);
  const [showH2, setShowH2] = useState(false);

  useEffect(() => {
    setShowH1(false);
  }, []);

  var onInViewChange = (inview) => {
    if (!showH1 && inview) setShowH1(true);
  };
  var onInViewChange2 = (inview) => {
    if (!showH2 && inview) setShowH2(true);
  };

  const props = useSpring({
    width: "100vw",
    overflowY: "hidden",
    from: { opacity: 0, marginTop: 150 },
    to: { opacity: 1, marginTop: 0 },
    config: { mass: 1, tension: 260, friction: 100 },
  });

  const reProp = useSpring({
    width: "100vw",
    overflowY: "hidden",
    from: { opacity: 0, marginTop: showH1 ? 150 : 0 },
    delay: 300,
    to: { opacity: showH1 ? 1 : 0, marginTop: 0 },
    config: { mass: 1, tension: 260, friction: 70 },
  });
  const props2 = useSpring({
    width: "25vw",
    from: { opacity: 0, marginLeft: showH1 ? -150 : 0 },
    to: { opacity: showH1 ? 1 : 0, marginLeft: 0 },
    delay: 400,
    config: { mass: 1, tension: 260, friction: 70 },
  });
  const props3 = useSpring({
    from: { opacity: 0, marginLeft: showH2 ? -200 : 0 },
    to: { opacity: showH2 ? 1 : 0, marginLeft: 0 },
    delay: 400,
    config: { mass: 1, tension: 260, friction: 70 },
  });

  const props4 = useSpring({
    from: { opacity: 0, marginRight: showH2 ? -200 : 0 },
    to: { opacity: showH2 ? 1 : 0, marginRight: 0 },
    config: { mass: 1, tension: 260, friction: 550 },
  });

  function projects() {
    if (isMobile) {
      scroller.scrollTo("scroll-to-element", {
        duration: 0,
        delay: 400,
        smooth: "easeOutQuad",
        offset: -30,
      });
    } else {
      scroller.scrollTo("scroll-to-element", {
        duration: 0,
        delay: 0,
        smooth: "easeOutQuad",
        offset: -30,
      });
    }
  }
  return (
    <div
      id="main"
      style={{
        width: "100vw",
        marginTop: "10vh",
        overflow: "hidden",
      }}
    >
      <div
        style={{ width: "100vw", position: "relative", overflow: "hidden" }}
        className="svgElem2"
      >
        {/* /////////////////// */}
        <InView onChange={onInViewChange}>
          <div
            id="aboutMe"
            style={{
              display: "flex",
              flexDirection: "row",
              overflow: "hidden",
            }}
          >
            <animated.div
              style={showH1 ? props : reProp}
              className="d-flex justify-content-start"
            >
              <div id="aboutMeChild" className="fw-bold ">
                <Element name="aboutMeScroll" className="element"></Element>
                <h1 className="fw-bold absCenter2 gFont">ABOUT ME</h1>
                <img
                  alt=""
                  id="imgMe"
                  src="me.png"
                  width="350vw"
                  style={{
                    // position:'absolute'
                    marginTop: "25vh",
                    marginLeft: "20vw",
                    borderRadius: "5%",
                  }}
                />
              </div>
            </animated.div>
            <animated.div
              id="ad2"
              className="d-flex flex-column align-items-center"
              style={props2}
            >
              <h5
                className="w-50 gFont fw-lighter"
                style={{
                  marginTop: "25vh",
                  fontSize: "1.3rem",
                  color: "white",
                  wordSpacing: "2px",
                  letterSpacing: "2px",
                  textAlign: "left",
                }}
                id="aboutMeText"
              >
                An ambitious problem solver and a independent Web Developer,
                having passion for collaborating and bringing the community
                close together to nurture the young talent.
                <br />
                Started app development in bachelor's degree, then got into Full
                stack development because of my curiosity in different
                technologies
                <br />
                <br />
                Currently working as a Full Stack Engineer at Sleepiz
                <br />
                <br />
                Recently working on
                <div className="d-flex mt-3">
                  <p id="techs">ReactJS</p>
                  <p id="techs">nodeJS (Express)</p>
                  <p id="techs">React-native</p>
                </div>
                <div className="d-flex">
                  <p id="techs">mysql</p>
                  <p id="techs">MongoDB</p>
                  <p id="techs">Firebase</p>
                </div>
              </h5>
              <div className="d-flex  justify-content-center" id="resumeButton">
                <button
                  className=" btn btn-background-slideWhite2 mt-5"
                  style={{ marginLeft: "5vw" }}
                  onClick={() => {
                    const newWindow = window.open(
                      "https://resume-neeleshwar.netlify.app/",
                      "_blank",
                      "noopener,noreferrer"
                    );
                    if (newWindow) newWindow.opener = null;
                  }}
                >
                  <strong className="strong">CV</strong>
                </button>
                <button
                  className=" btn btn-background-slideWhite2 mt-5"
                  style={{ marginLeft: "5vw" }}
                  onClick={projects}
                >
                  <strong className="strong">Projects</strong>
                </button>
              </div>
            </animated.div>
          </div>
        </InView>
        {/* //////////////////// */}
        <svg
          id="svgID"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="white"
            fillOpacity="1"
            d="M0,320L1440,192L1440,320L0,320Z"
          ></path>
        </svg>
      </div>

      {/* Out side svg interference */}
      <InView onChange={onInViewChange2}>
        <Element name="scroll-to-element" className="element"></Element>
        <div
          id="projectsDiv"
          className="d-flex container h-25 align-items-center flex-column"
        >
          <h1 className="fw-bold gFont">PROJECTS</h1>

          <div id="projectDiv" className="d-flex w-100 mt-5  ">
            <animated.div style={props3}>
              <div className="d-flex flex-column  justify-content-center align-items-center ">
                <p className="p1">
                  <h3 className="fw-bolder">NFT MarketPlace :-</h3>
                  <br />A complete solution for NFT's sale and purchase,
                  Complete Marketplace with versions SingleVendor and
                  Multivendor.
                  <p className="fw-bold mt-2 " id="techDes">
                    NextJS, nodeJS, Solidity and hardhat.
                  </p>
                  <p className="fw-bold" id="techDes">
                    Ipfs and MongoDB for storage.
                  </p>
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className=" btn btn-background-slideWhite me-3 "
                    onClick={() => {
                      window.open(
                        "https://nftkart.queppelinsolutions.com/",
                        ""
                      );
                    }}
                  >
                    See Live
                  </button>
                </div>
              </div>
            </animated.div>
            <animated.div style={props4}>
              <HoverCard image={"nft"} />
            </animated.div>
          </div>

          <div id="projectDiv" className="d-flex w-100 mt-5  ">
            <animated.div style={props3}>
              <div className="d-flex flex-column  justify-content-center align-items-center ">
                <p className="p1">
                  <h3 className="fw-bolder">NFT Creator :-</h3>
                  <br />
                  No code NFT generator for NFT lovers.Gather your assets
                  specify layers and generate thousands of NFTs.
                  <p className="fw-bold mt-2 " id="techDes">
                    NextJS, nodeJS, Solidity and hardhat.
                  </p>
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className=" btn btn-background-slideWhite me-3 "
                    onClick={() => {
                      window.open(
                        "https://bulknftcreator.queppelinsolutions.com/",
                        ""
                      );
                    }}
                  >
                    See Live
                  </button>
                </div>
              </div>
            </animated.div>
            <animated.div style={props4}>
              <HoverCard image={"nft"} />
            </animated.div>
          </div>
          <div id="projectDiv" className="d-flex w-100 mt-5">
            <animated.div style={props3}>
              <div className="d-flex flex-column  justify-content-center align-items-center ">
                <p className="p1">
                  <h3 className="fw-bolder">BNF-drive :-</h3>
                  <br />
                  Cloud storage web app to keep all your photos,videos and
                  documents safe.
                  <p className="fw-bold mt-2 " id="techDes">
                    I have built this app in REACT JS and firebase.
                  </p>
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className=" btn btn-background-slideWhite me-3 "
                    onClick={() => {
                      window.open("https://bnf-drive.netlify.app/", "");
                    }}
                  >
                    See Live
                  </button>
                  <a
                    href="https://github.com/neeleshwark17/bnf-drive"
                    style={{ textDecoration: "none" }}
                    className="ms-3"
                  >
                    <strong className="strong gFont gColor">Source code</strong>
                  </a>
                </div>
              </div>
            </animated.div>
            <animated.div style={props4}>
              <HoverCard image={"drive"} />
            </animated.div>
          </div>

          <div id="projectDiv" className="d-flex w-100 mt-5 mb-5 ">
            <animated.div style={props3}>
              <div className="d-flex flex-column  justify-content-center align-items-center ">
                <p className="p1">
                  <h3 className="fw-bolder">BNF-Chats :-</h3>
                  <br />
                  An chat app developed in ReactJS using socketIO library and
                  nodeJS.
                  <p className="fw-bold mt-2 " id="techDes">
                    I have built this app in REACT JS and socketIO and nodeJS.
                  </p>
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className="btn btn-background-slideWhite me-3 "
                    onClick={() => {
                      window.open("https://bnf-chats.herokuapp.com/", "");
                    }}
                  >
                    See Live
                  </button>
                  <a
                    href="https://github.com/neeleshwark17/bnf-chats"
                    style={{ textDecoration: "none" }}
                    className="ms-3"
                  >
                    <strong className="strong gFont gColor">Source code</strong>
                  </a>
                </div>
              </div>
            </animated.div>
            <animated.div style={props4}>
              <HoverCard image={"bnfChats"} />
            </animated.div>
          </div>
        </div>
      </InView>
      <div className="d-flex w-100 justify-content-center mt-5 " id="seeAll">
        <button
          className=" btn btn-background-slideWhite me-3 "
          style={{ width: "fit-content" }}
          onClick={() => {
            window.location.href = "/Work";
          }}
        >
          See More Projects
        </button>
      </div>
    </div>
  );
}
